// Brand panel on the login screen (CEO 13/09/2026: layout A, brand-brown panel).
// Follows the Gạo Nâu brand guide v3: official wordmark + monogram in cream on
// the brown panel, "ERP" kept as a separate eyebrow label (never merged into
// the logo), pattern tile only as a faint corner background (never behind long
// text), no italics.
import { BRAND_ART, BrandMark, BrandTile } from "@/components/BrandArt";
import { LoginClock } from "./LoginClock";
import { quoteOfTheDay } from "./quotes";

/**
 * Brand brown — the same brown as the app sidebar (`--color-brand` #8B6914 in
 * tokens.css), deepening to `--color-brand-dark` #6B5010 at the bottom-right
 * corner. CEO 13/09/2026 rejected the dark bordeaux gradient: "phải trả về màu
 * nâu". Cream text stays at full opacity here — on this brown, any opacity
 * below 1 drops small text under the 4.5:1 AA contrast the spec requires.
 */
const NEN_NAU = "linear-gradient(122deg, #8B6914 0%, #8B6914 35%, #7A5B12 75%, #6B5010 100%)";

/** Corner-only fade so the rice scatter never sits behind the paragraph (brand guide §4.1). */
const MAT_NA_GOC = "linear-gradient(to bottom left, #000, transparent 60%)";

/** Company intro — CEO approved verbatim (10a). */
export const GIOI_THIEU =
  "Gạo Nâu là hệ sinh thái thương hiệu về hình ảnh và trải nghiệm làm đẹp tại Hà Nội và " +
  "TP. Hồ Chí Minh — từ ảnh thẻ, ảnh profile, chụp ảnh nghệ thuật đến du lịch chụp ảnh và " +
  "trang điểm tại nhà. Mỗi ngày, chúng ta cùng nhau giữ lại những khoảnh khắc khách hàng " +
  "muốn nhớ mãi.";

export function LoginBrandPanel() {
  const quote = quoteOfTheDay();

  return (
    <section
      aria-label="Giới thiệu Gạo Nâu"
      className="relative shrink-0 overflow-hidden px-7 pb-8 pt-9 text-[#FFFEF5] lg:flex lg:w-[52%] lg:flex-col lg:justify-between lg:px-20 lg:py-[72px]"
      style={{ background: NEN_NAU }}
    >
      {/* Mockup 28/09/2026: the tall stacked GAO NAU lettering, sunk into the
          brown and bleeding off the right edge; rice grains in the top-right
          corner only. Both stay behind the text at low opacity. */}
      <BrandMark
        src={BRAND_ART.tallLettering}
        className="absolute -right-24 top-6 h-[520px] w-[560px] text-[#FFFEF5]/10 lg:-right-10 lg:top-[-40px] lg:h-[780px] lg:w-[640px]"
      />
      <BrandTile
        src={BRAND_ART.riceScatter}
        size={260}
        fade={MAT_NA_GOC}
        className="text-[#FFFEF5]/15"
      />

      <h1 className="relative m-0">
        <span className="flex items-center gap-4">
          <img
            src="/images/brand/gao-nau-monogram-kem.svg"
            alt=""
            className="h-14 w-auto lg:h-[84px]"
          />
          <img
            src="/images/brand/gao-nau-wordmark-kem.svg"
            alt="GẠO NÂU"
            className="h-[34px] w-auto lg:h-[52px]"
          />
        </span>{" "}
        <span className="mt-2 block text-[11px] font-semibold uppercase tracking-[0.18em] lg:mt-3 lg:text-[13px]">
          ERP · Hệ thống quản lý nội bộ
        </span>
      </h1>

      {/* Middle group: live clock + lunar date (CEO 13/09/2026), then the intro. */}
      <div className="relative mt-7 lg:mt-0">
        <LoginClock />
        <p className="m-0 mt-6 max-w-[520px] text-[15px] leading-relaxed lg:mt-8 lg:text-[17px]">
          {GIOI_THIEU}
        </p>
      </div>

      {/* Quote of the day — CEO 13/09/2026 dropped the "Câu của hôm nay" caption, kept the quote. */}
      <figure className="relative m-0 mt-6 max-w-[520px] pl-5 lg:mt-0">
        <span
          aria-hidden="true"
          className="absolute inset-y-1 left-0 w-[2px]"
          style={{ background: "var(--gn-foil)" }}
        />
        <blockquote className="m-0 text-[17px] font-medium leading-snug lg:text-[22px]">
          {`“${quote}”`}
        </blockquote>
      </figure>
    </section>
  );
}
